import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmptyComponent } from '@shared/empty/empty.component';
import { environment } from '@env/environment';

const routes: Routes = [
  ...environment.routes,
  // Required. Do not remove
  { path: '**', component: EmptyComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class MncDmePosRoutingModule {}
